function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M3.697,6.782h75c1.656,0,3-1.343,3-3s-1.344-3-3-3h-75c-1.657,0-3,1.343-3,3S2.04,6.782,3.697,6.782z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M78.697,28.197H10.939l5.189-5.19c1.172-1.172,1.172-3.07,0-4.242c-1.171-1.172-3.07-1.172-4.241,0 L1.576,29.075c-0.714,0.714-1.004,1.726-0.817,2.691c0.001,0.005,0.003,0.01,0.004,0.015c0.037,0.19,0.087,0.379,0.163,0.563 c0.071,0.172,0.161,0.329,0.26,0.481c0.017,0.025,0.036,0.05,0.053,0.075c0.09,0.13,0.188,0.251,0.298,0.364 c0.019,0.019,0.03,0.041,0.048,0.059l10.313,10.312c0.586,0.587,1.354,0.88,2.121,0.88s1.536-0.293,2.122-0.88 c1.171-1.172,1.171-3.07,0-4.242l-5.196-5.196h67.755c1.656,0,3-1.343,3-3S80.354,28.197,78.697,28.197z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M78.697,55.611h-75c-1.657,0-3,1.344-3,3c0,1.657,1.343,3,3,3h75c1.656,0,3-1.343,3-3 C81.697,56.955,80.354,55.611,78.697,55.611z"
});

var SvgChiudiMenu = function SvgChiudiMenu(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "81px",
    height: "60.83px",
    viewBox: "0 0 81 60.83",
    enableBackground: "new 0 0 81 60.83",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChiudiMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chiudiMenu.6862e430.svg";
export { ForwardRef as ReactComponent };